import { sm2 } from 'sm-crypto';
// 1 - C1C3C2，0 - C1C2C3，默认为1
const cipherMode: number = 1;

// 加密
// value：需要加密的内容
export function encrypt(value, publicKey: string) {
  // 给后端传值时需要在加密的密文前面加04 ,这样后端才能解密正确不报错
  return `04${sm2.doEncrypt(value, publicKey, cipherMode)}`;
}

// 解密
// value：需要解密的密文
export function decrypt(value, privateKey: string) {
  // 后端传输过来的密文开头的两个字符通常也为04，因此解密时需要删除
  return sm2.doDecrypt(value?.slice(2, value.length), privateKey, cipherMode);
}
